import React, { useState, useEffect, useContext } from "react";
import EmpresaContext from "../../../../contexts/Empresa";
import api from "../../../../services/api";
import { bindErrors } from "../../../../utils";
import { SubmitContainer } from "../Encaminhar/styles";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Pagination from "../../../../components/Pagination";
import Select2 from "react-select2-wrapper";
import {
  Button,
  ListGroupItem,
  Row,
  Col,
  ListGroup,
  Modal,
  Spinner,
  Progress,
  FormGroup,
  InputGroup,
  Input,
} from "reactstrap";

function AlterarEstagio({
  show,
  onClose,
  onSuccess,
  notify,
  oportunidades,
}) {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [funis, setFunis] = useState([]);
  const [funilId, setFunilId] = useState(null);
  const [estagiosFunil, setEstagiosFunil] = useState([]);
  const [estagioParaId, setEstagioParaId] = useState(null);
  const [pageProperties, setPageProperties] = useState({});
  const [selecionadas, setSelecionadas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [page, setPage] = useState(0);
  const [erros, setErros] = useState({});
  const [alert, setAlert] = useState(null);
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    if (!show) return;
    setSelecionadas([]);
    setFunilId(null);
    setEstagioParaId(null);
    setEstagiosFunil([]);
    setPage(0);
    setCheckAll(false);
    setErros({});
    setPageProperties(oportunidades);
    loadFunis();
  }, [show]);

  useEffect(() => {
    setEstagioParaId(null);
    setSelecionadas([]);
    setCheckAll(false);
    if (!funilId) {
      setEstagiosFunil([]);
      return;
    }
    const funil = funis.find((f) => String(f.id) === String(funilId));
    setEstagiosFunil(funil?.estagios || []);
  }, [funilId]);

  useEffect(() => {
    if (checkAll) {
      setSelecionadas(oportunidadesFiltradas().map((op) => op.id));
    } else {
      setSelecionadas([]);
    }
  }, [checkAll]);

  async function loadFunis() {
    setLoading(true);
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/funis?tipo=crm`
      );
      setFunis(response.data || []);
    } catch (error) {
      console.error(error);
      if (notify) notify("danger", "Não foi possível carregar funis");
    } finally {
      setLoading(false);
    }
  }

  function oportunidadesFiltradas() {
    const data = pageProperties?.data || [];
    return data.filter((op) => {
      if (funilId && String(op.funil_id) !== String(funilId)) return false;
      return true;
    });
  }

  function handleSelectItem(oportunidadeId) {
    let list = [...selecionadas];
    if (selecionadas.includes(oportunidadeId)) {
      list.splice(list.indexOf(oportunidadeId), 1);
    } else {
      list.push(oportunidadeId);
    }
    setSelecionadas(list);
  }

  function handleAlterar() {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title={`Alterar estágio de ${selecionadas.length} oportunidade(s)?`}
        onConfirm={alterar}
        onCancel={() => setAlert(null)}
        showCancel
        reverseButtons
        confirmBtnBsStyle="primary"
        confirmBtnText="Sim"
        cancelBtnBsStyle="link"
        cancelBtnText="Não"
        btnSize=""
      />
    );
  }

  async function alterar() {
    setSaving(true);
    setAlert(null);
    try {
      const { data } = await api.post(
        `/common/empresas/${empresaSelecionada.id}/oportunidades/alterar-estagio-oportunidades`,
        {
          oportunidadesIds: selecionadas,
          estagio_id: parseInt(estagioParaId),
        }
      );
      const totalAlteradas = data?.alteradas?.length || 0;
      const totalIgnoradas = data?.ignoradas?.length || 0;
      if (totalIgnoradas > 0 && notify) {
        notify(
          "warning",
          `${totalAlteradas} alteradas, ${totalIgnoradas} ignoradas.`
        );
      }
      showSuccess(`${totalAlteradas} oportunidade(s) movidas`);
    } catch (error) {
      console.error(error);
      if (error.response) {
        const errorMessage = bindErrors(error.response.data);
        if (errorMessage) {
          typeof errorMessage === "string"
            ? showError(errorMessage)
            : setErros(errorMessage);
        } else {
          showError("Não foi possível alterar estágio das oportunidades");
        }
      }
    }
    setSaving(false);
  }

  function showSuccess(msg) {
    onSuccess && onSuccess();
    setAlert(
      <ReactBSAlert
        success
        title={msg}
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        showConfirm={false}
        timeout={2000}
      />
    );
    setTimeout(() => onClose(), 2000);
  }

  function showError(msg) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Atenção"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="warning"
        confirmBtnText="Ok"
        btnSize=""
      >
        {msg}
      </ReactBSAlert>
    );
  }

  function handleClose() {
    if (!saving) onClose();
  }

  const filtradas = oportunidadesFiltradas();

  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={show}
      toggle={handleClose}
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">Alterar Estágios das Oportunidades</h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden>×</span>
        </button>
      </div>
      <div className="modal-body">
        {alert}
        {loading ? (
          <Progress animated value="100" color="info" />
        ) : (
          <>
            <Row className="mb-3">
              <Col xs="12" lg="12">
                <FormGroup>
                  <label className="form-control-label">Funil*</label>
                  <InputGroup className="input-group-alternative">
                    <Select2
                      onSelect={({ target }) => setFunilId(target.value)}
                      options={{ placeholder: "Selecione um funil..." }}
                      value={funilId}
                      data={funis.map((item) => ({
                        id: item.id,
                        text: item.nome,
                      }))}
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs="12" lg="12">
                <FormGroup>
                  <label className="form-control-label">Estágio destino*</label>
                  <InputGroup className="input-group-alternative">
                    <Select2
                      onSelect={({ target }) => setEstagioParaId(target.value)}
                      options={{
                        placeholder: "Selecione estágio de destino...",
                      }}
                      value={estagioParaId}
                      data={estagiosFunil.map((item) => ({
                        id: item.id,
                        text: item.nome,
                      }))}
                    />
                  </InputGroup>
                  <small className="text-danger">
                    {erros.estagio_id || ""}
                  </small>
                </FormGroup>
              </Col>
            </Row>

            <SubmitContainer>
              <Button
                onClick={handleAlterar}
                color="primary"
                disabled={
                  saving ||
                  selecionadas.length <= 0 ||
                  !estagioParaId ||
                  !funilId
                }
              >
                {saving && <Spinner size="sm" className="mr-2" />}
                Alterar estágio
              </Button>
            </SubmitContainer>
            <small className="text-danger">{erros.oportunidadesIds || ""}</small>
            <br />
            <ListGroup data-toggle="checklist" flush>
              <ListGroupItem className="checklist-entry flex-column align-items-start py-4 px-4">
                <FormGroup
                  check
                  className="form-check-inline"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <small>
                    {`${selecionadas.length} oportunidades selecionadas`}
                  </small>
                  <div
                    className="custom-control custom-checkbox custom-checkbox-primary"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <small>Todas</small>
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      checked={checkAll}
                      onClick={() => setCheckAll(!checkAll)}
                    />
                  </div>
                </FormGroup>
              </ListGroupItem>
              {filtradas
                .slice(page * 6, (page + 1) * 6)
                .map((oportunidade, key) => (
                  <ListGroupItem
                    key={key}
                    className="checklist-entry flex-column align-items-start py-4 px-4"
                  >
                    <div className="checklist-item checklist-item-primary">
                      <div className="checklist-primary">
                        <h5 className="checklist-title mb-0">
                          {oportunidade.cliente?.nome}
                        </h5>
                        <small>{`Colaborador: ${
                          oportunidade?.user?.name || ""
                        }`}</small>
                      </div>
                      <div>
                        <FormGroup check inline>
                          <Input
                            type="checkbox"
                            style={{ borderColor: "#1c2024" }}
                            checked={selecionadas.includes(oportunidade.id)}
                            onClick={() => handleSelectItem(oportunidade.id)}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
            </ListGroup>
            <small>{`${filtradas.length} oportunidades carregadas`}</small>
            {filtradas.length > 0 && (
              <Pagination
                pageProperties={{
                  perPage: 6,
                  page: page + 1,
                  lastPage: Math.ceil(filtradas.length / 6),
                }}
                load={(pp) => setPage((pp?.page || 1) - 1)}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
}

export default AlterarEstagio;
